module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.$t('module.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 640
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['modulos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'modulo', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['modulos:delete']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'modulo')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['permisos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.openPermisos(items.item)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "primary"
          }
        }, [_vm._v("security")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar permisos")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['modulos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": "ACTIVE",
            "color": "success"
          },
          on: {
            "change": function($event) {
              return _vm.changeActive(items.item, items.item.id, 'modulo', 'EditModulo', _vm.getMenu)
            }
          },
          slot: "activator",
          model: {
            value: (items.item.active),
            callback: function($$v) {
              _vm.$set(items.item, "active", $$v)
            },
            expression: "items.item.active"
          }
        }), _vm._v(" "), _c('span', [_vm._v("Activar/desactivar registro")])], 1) : _c('v-icon', {
          attrs: {
            "color": items.item.active === 'ACTIVE' ? 'success' : 'error'
          }
        }, [_vm._v("\n              " + _vm._s(items.item.active === 'ACTIVE' ? 'check' : 'close') + "\n            ")])], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['modulos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": true,
            "color": "info"
          },
          on: {
            "change": function($event) {
              return _vm.changeVisible(items.item, items.item.id)
            }
          },
          slot: "activator",
          model: {
            value: (items.item.visible),
            callback: function($$v) {
              _vm.$set(items.item, "visible", $$v)
            },
            expression: "items.item.visible"
          }
        }), _vm._v(" "), _c('span', [_vm._v("Poner como visible en el menú")])], 1) : _c('v-icon', {
          attrs: {
            "color": items.item.visible ? 'success' : 'error'
          }
        }, [_vm._v("\n              " + _vm._s(items.item.active === 'ACTIVE' ? 'check' : 'close') + "\n            ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.ruta))]), _vm._v(" "), _c('td', [(items.item.icono) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-icon', {
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v(_vm._s(items.item.icono))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(items.item.icono))])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getModulo(items.item.id_modulo)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(items.item.orden))]), _vm._v(" "), _c('td', [(items.item.visible) ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              VISIBLE\n            ")]) : _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              OCULTO\n            ")])], 1), _vm._v(" "), _c('td', [(items.item.estado == 'ACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'INACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['modulos:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openModal()
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v(" " + _vm._s(_vm.$t('common.add')))], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('module.add')))])], 1) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-icon', [_vm._v("business")]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('module.crud.editModule') : _vm.$t('module.crud.addModule')) + "\n            ")], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [(_vm.form.estado == 'ACTIVO') ? _c('v-chip', {
    attrs: {
      "label": "",
      "color": "success",
      "text-color": "white"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.estado) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.form.estado == 'INACTIVO') ? _c('v-chip', {
    attrs: {
      "label": "",
      "color": "warning",
      "text-color": "white"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.estado) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "label",
      "label": _vm.$t('module.crud.label'),
      "autofocus": "",
      "maxlength": "50",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.label),
      callback: function($$v) {
        _vm.$set(_vm.form, "label", $$v)
      },
      expression: "form.label"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "ruta",
      "label": _vm.$t('module.crud.path'),
      "maxlength": "50",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.ruta),
      callback: function($$v) {
        _vm.$set(_vm.form, "ruta", $$v)
      },
      expression: "form.ruta"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "disabled": _vm.isSection,
      "name": "icono",
      "label": _vm.$t('module.crud.icon'),
      "maxlength": "30"
    },
    model: {
      value: (_vm.form.icono),
      callback: function($$v) {
        _vm.$set(_vm.form, "icono", $$v)
      },
      expression: "form.icono"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "orden",
      "label": "Nro. de orden",
      "maxlength": "3",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.orden),
      callback: function($$v) {
        _vm.$set(_vm.form, "orden", $$v)
      },
      expression: "form.orden"
    }
  })], 1), _vm._v(" "), (!_vm.form.id) ? _c('v-flex', {
    attrs: {
      "xs5": "",
      "justify-center": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "value": true,
      "label": "Visible en el menú",
      "color": "info",
      "required": ""
    },
    model: {
      value: (_vm.form.visible),
      callback: function($$v) {
        _vm.$set(_vm.form, "visible", $$v)
      },
      expression: "form.visible"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('h4', [_vm._v("Dependencias")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "value": true,
      "label": "¿Depende de otro módulo?",
      "color": "info"
    },
    model: {
      value: (_vm.isSection),
      callback: function($$v) {
        _vm.isSection = $$v
      },
      expression: "isSection"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.isSection) ? _c('v-select', {
    attrs: {
      "items": _vm.modulos,
      "label": "Módulo padre",
      "item-text": "text",
      "item-value": "value",
      "rules": _vm.$validate(['required']),
      "required": ""
    },
    model: {
      value: (_vm.form.id_modulo),
      callback: function($$v) {
        _vm.$set(_vm.form, "id_modulo", $$v)
      },
      expression: "form.id_modulo"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
    staticClass: "error--text text-required"
  }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal');
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')) + "\n              ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "type": "submit",
      "disabled": !_vm.valid
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')) + "\n              ")], 1)], 1)], 1)], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "960"
    },
    model: {
      value: (_vm.$store.state.modal2),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal2", $$v)
      },
      expression: "$store.state.modal2"
    }
  }, [(_vm.roles.length) ? _c('permisos', {
    attrs: {
      "modulo": _vm.modulo,
      "roles": _vm.roles
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24ddd26f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/modulo/Modulo.vue
// module id = 503
// module chunks = 2